/**
 * @param {object} filters
 * @returns {array}
 */
const getStatusFilter = (filters) => {
  const { statuses = [], cancelled, no_cargo_manifest } = filters;

  if (cancelled) {
    return ['CANCELLED', 'DONE_WITH_CANCELLATIONS'];
  }

  if (no_cargo_manifest) {
    return ['DONE_WITHOUT_MANIFEST'];
  }

  return statuses;
};

export default getStatusFilter;
